import { forwardRef } from 'react';
import { Add, Attach, Delete, Download, Edit, Export, Filter, Import, NewStarburst, Open, Redo, Refresh, Reset, Save, SaveAs, Undo, Upload } from '@sas/react-svg';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { Button, ButtonVariant } from '../../Button';
import bundle from '../NovaComponents-Toolbar-gui-icu.properties';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const PredefinedButton = /*#__PURE__*/forwardRef(function PredefinedButton({
  type,
  iconOnly,
  behaviorType,
  ...props
}, ref) {
  const localize = useTextLocalizer();
  const {
    icon,
    text
  } = getIconText(type, iconOnly, localize);
  const defaultVariant = iconOnly ? ButtonVariant.Icon : undefined;
  return /*#__PURE__*/_jsx(Button, {
    ...props,
    ref: ref,
    icon: icon,
    text: text,
    variant: props.variant ?? defaultVariant,
    type: behaviorType
  });
});
export const getIconText = (type, iconOnly = false, localize) => {
  let icon;
  let text;
  switch (type) {
    case 'open':
      icon = Open;
      text = localize('predefinedButton.open.button.label');
      break;
    case 'new':
      icon = NewStarburst;
      text = localize('predefinedButton.new.button.label');
      break;
    case 'edit':
      icon = Edit;
      text = localize('predefinedButton.edit.button.label');
      break;
    case 'delete':
      icon = Delete;
      text = localize('predefinedButton.delete.button.label');
      break;
    case 'save':
      icon = Save;
      text = localize('predefinedButton.save.button.label');
      break;
    case 'saveAs':
      icon = SaveAs;
      text = localize('predefinedButton.saveAs.button.label');
      break;
    case 'upload':
      icon = Upload;
      text = localize('predefinedButton.upload.button.label');
      break;
    case 'download':
      icon = Download;
      text = localize('predefinedButton.download.button.label');
      break;
    case 'refresh':
      icon = Refresh;
      text = localize('predefinedButton.refresh.button.label');
      break;
    case 'reset':
      icon = Reset;
      text = localize('predefinedButton.reset.button.label');
      break;
    case 'undo':
      icon = Undo;
      text = localize('predefinedButton.undo.button.label');
      break;
    case 'redo':
      icon = Redo;
      text = localize('predefinedButton.redo.button.label');
      break;
    case 'filter':
      icon = Filter;
      text = localize('predefinedButton.filter.button.label');
      break;
    case 'attach':
      icon = Attach;
      text = localize('predefinedButton.attach.button.label');
      break;
    case 'add':
      icon = Add;
      text = localize('predefinedButton.add.button.label');
      break;
    case 'import':
      icon = Import;
      text = localize('predefinedButton.import.button.label');
      break;
    case 'export':
      icon = Export;
      text = localize('predefinedButton.export.button.label');
      break;
  }
  return {
    icon: iconOnly ? {
      icon
    } : undefined,
    text: iconOnly ? undefined : text
  };
};
//# sourceMappingURL=PredefinedButton.js.map